import React, { useContext, useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../services/firebaseConfig";
import { useNavigate } from "react-router-dom";

import css from "./Pro.module.css";
import { UserContext } from "../../context/UserContext";
import { Head } from "../../utils/Head";

export const ProUserPage = () => {
  const { userData } = useContext(UserContext);
  const [meetings, setMeetings] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchMeetings() {
      if (!userData?.email) return;

      try {
        // 🔹 Busca todas as reuniões onde o participante está incluído
        const q = query(collection(db, "meetings"));
        const snapshot = await getDocs(q);

        const userMeetings = snapshot.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .filter((m) => m.participants?.includes(userData.email));

        setMeetings(userMeetings);
      } catch (error) {
        console.error("Erro ao buscar reuniões:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchMeetings();
  }, [userData]);

  if (loading) return <p>Carregando...</p>;

  return (
    <div className={css.container}>
      <Head title="Minhas Reuniões" description="Reuniões do participante" />
      <h2>Meus Encontros</h2>

      {meetings.length === 0 ? (
        <p>Nenhuma reunião disponível.</p>
      ) : (
        <ul className={css.meetingsList}>
          {meetings.map((m) => (
            <li
              key={m.id}
              className={`${css.meetingCard} ${
                m.type === "health" ? css.health : css.consultation
              }`}
            >
              <h3 className={css.meetingCardTitle}>{m.title}</h3>
              <p className={css.meetingCardDate}>
                <strong>Data:</strong>{" "}
                {/* {new Date(m.scheduleFor).toLocaleString("pt-BR")} */}
                {new Date(m.scheduleFor).toLocaleDateString("pt-BR", {
                  weekday: "long",
                  day: "2-digit",
                  month: "2-digit",
                  year: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </p>
              <div className={css.meetingDetails}>
                <p>
                  <strong>Status:</strong> {m.status}
                </p>
                <p>
                  <strong>Participantes ({m.participants.length}):</strong>{" "}
                  {m.participants[0]}, {m.participants[1]}
                </p>
              </div>
              <button
                className="saveButton"
                onClick={() => navigate(`meeting/${m.id}`)}
              >
                Detalhes
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
